// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { lazy } from 'react'
import { DisengagementVoicebotAreaId } from './DisengagementVoicebotAreaId'
import {
  DisengagementVoicebotAreaNavigation,
  DisengagementVoicebotAreaNavigationIcon,
} from './DisengagementVoicebotAreaNavigation'
import { DisengagementVoicebotAreaRoutes } from './DisengagementVoicebotAreaRoutes'

const LazyDisengagementVoicebotComponent = lazy(
  () => import('./DisengagementVoicebotArea'),
)

const DisengagementVoicebotComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyDisengagementVoicebotComponent />
  </SuspenseLoadingWrapper>
)

export const DisengagementVoicebotArea = {
  id: DisengagementVoicebotAreaId,
  Icon: DisengagementVoicebotAreaNavigationIcon,
  NavigationComponent: DisengagementVoicebotAreaNavigation,
  route: {
    path: DisengagementVoicebotAreaRoutes.route,
    component: DisengagementVoicebotComponent,
  },
}
